import React, { Component } from 'react';
import { Form, Row, Col, Button, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faFileCsv, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { faFileExcel, faFileText } from '@fortawesome/free-regular-svg-icons';
import { getInitData, getComboData, getSearchData, getSearchXls, getSearchCsv, getSearchXml } from '../Api/SearchApi';
import { saveAsFile } from "../Shared/Utils";
import Grid from '../Grid/Grid';


const gridDefault = {
    columns: [{dataField: 'oib', text: ''}],
    data: [],
    count: 0
};


export default class searchParams extends Component {
    loaded = false;
    constructor(props) {
        super(props)
        this.state = {
            godine: [],
            konta: [],
            aktivnosti: [],
            izvori: [],
            grid: {...gridDefault},
            searchParams: {
                godina: "",
                konto: "",
                aktivnost: "",
                izvori: "",
                oib: "",
                dobavljac: "",
                mjesto: "",
                posta: ""
            },
            isLoading: false,
            infoMessage: "",
            xlsFile: {
                name: "",
                base64: ""
            },
            naslov: "",
            podnozje: "",
            isDisabled: true
        }
    }

    componentDidMount() {
        if (!this.loaded) this.loadOnce();
    }

    loadOnce() {
        this.loaded = true;
        getInitData()
            .then(res => {
                this.setState( prevState => ({
                    godine: res.data.godine,
                    naslov: res.data.naslov,
                    podnozje: res.data.podnozje
                }))
            })
            .catch(error => {
                this.handleError(error);
            })
    }

    handleError = e => {
        let err = "";
        if (e.response){
            err = e.response.data.error;
        }else if (e.message){
            err = e.message;
        }        
        console.log("ERROR -> " + err);
        this.setState({
            infoMessage: err
        })
    }

    addGridIndex = arr => {
        let data = arr.map((e, i) => {
            return {...e, rb: i}
        })
        return data;
    }

    isDisabled = () => {
        return (this.state.isLoading || this.state.searchParams.godina === "")
    }

    onGodinaChange = e => {
        if (e === "") return;
        getComboData(e)
            .then(res => {
                this.setState({
                    aktivnosti: res.data.aktivnosti,
                    konta: res.data.konta,
                    izvori: res.data.izvori
                })
            })
            .catch(error => {
                this.handleError(error);
            })
    }

    onControlChange = e => {
        let { name, value } = e.target;
        if (name === "godina") this.onGodinaChange(value);
        this.setState(prevState => ({
            searchParams: {
                ...prevState.searchParams,
                [name]: value
            }
        }))
    }

    onBtnSearch = () => {
        this.setState({isLoading: true, infoMessage: "", grid: {...gridDefault} });
        getSearchData(this.state.searchParams)
            .then(res => {
                if (res.data && res.data.error){
                    throw new Error(res.data.error);
                }else{
                    console.log(res.data);
                    let grid = {
                        columns: res.data.columns,
                        data: this.addGridIndex(res.data.data),
                        count: res.data.count
                    }
                    this.setState({
                        grid: grid,
                        isLoading: false
                    })    
                }
            })
            .catch(error => {
                this.setState({isLoading: false});
                this.handleError(error);
            })
    }

    onBtnXlsx = () => {
        this.setState({isLoading: true, infoMessage: "",  grid: {...gridDefault} });
        getSearchXls(this.state.searchParams)
            .then(res => {
                if (res.data && res.data.error){
                    throw new Error(res.data.error);
                }else{
                    saveAsFile(res.data.fields.FFileName, 'xls', res.data.fields.FBase64);
                    this.setState({isLoading: false});                    
                }
            })
            .catch(error => {
                this.setState({isLoading: false});
                this.handleError(error);
            })
    }

    onBtnCsv = () => {
        this.setState({isLoading: true, infoMessage: "",  grid: {...gridDefault} });
        getSearchCsv(this.state.searchParams)
            .then(res => {                
                if (res.data && res.data.error){
                    throw new Error(res.data.error);
                }else{
                    saveAsFile(res.data.fields.FFileName, 'csv', res.data.fields.FBase64);
                    this.setState({isLoading: false});    
                }
            })
            .catch(error => {
                this.setState({isLoading: false});
                this.handleError(error);
            })
    }

    onBtnXml = () => {
        this.setState({isLoading: true, infoMessage: "", grid: {...gridDefault} });
        getSearchXml(this.state.searchParams)
            .then(res => {                
                if (res.data && res.data.error){
                    throw new Error(res.data.error);
                }else{
                    saveAsFile(res.data.fields.FFileName, 'xml', res.data.fields.FBase64);
                    this.setState({isLoading: false});    
                }
            })
            .catch(error => {
                this.setState({isLoading: false});
                this.handleError(error);
            })
    }    

    render() {
        let dataComponent;
        if (this.state.infoMessage !== ""){
            dataComponent = (<Alert variant="danger" onClose={() => this.setState({infoMessage: ""})} dismissible>{this.state.infoMessage}</Alert>)
        }else if(this.state.grid.count !== 0) {
            dataComponent = ( <Grid columns={this.state.grid.columns} data={this.state.grid.data} count={this.state.grid.count} podnozje={this.state.podnozje} />
            )
        }        
        return (
            <>
                <h2 className="text-center">{this.state.naslov}</h2>
                <p></p>                        
                <Form>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Godina</Form.Label>
                                <Form.Select name="godina" onChange={e => this.onControlChange(e)}>
                                    <option value="">Odaberite godinu</option>
                                    {this.state.godine.map((obj, i) =>
                                        <option key={"godine" + i} value={obj.value}>{obj.text}</option>
                                    )}

                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Konto</Form.Label>
                                <Form.Select name="konto" onChange={e => this.onControlChange(e)}>
                                    <option value="">Sve</option>
                                    {this.state.konta.map((obj, i) =>
                                        <option key={"konta" + i} value={obj.value}>{obj.value} - {obj.text}</option>
                                    )}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Aktivnost</Form.Label>
                                <Form.Select name="aktivnost" onChange={e => this.onControlChange(e)}>
                                    <option value="">Sve</option>
                                    {this.state.aktivnosti.map((obj, i) =>
                                        <option key={"aktivnosti" + i} value={obj.value}>{obj.value} - {obj.text}</option>
                                    )}
                                </Form.Select>
                            </Form.Group>

                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Izvori</Form.Label>
                                <Form.Select name="izvori" onChange={e => this.onControlChange(e)}>
                                    <option value="0">Sve</option>
                                    {this.state.izvori.map((obj, i) =>
                                        <option key={"izvori" + i} value={obj.value}>{obj.value} - {obj.text}</option>
                                    )}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <p></p>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Oib</Form.Label>
                                <Form.Control name="oib" type="text" maxLength="13" onChange={e => this.onControlChange(e)} />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Naziv dobavljača</Form.Label>
                                <Form.Control name="dobavljac" type="text" maxLength="40" onChange={e => this.onControlChange(e)} />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Mjesto</Form.Label>
                                <Form.Control name="mjesto" type="text" maxLength="30" onChange={e => this.onControlChange(e)} />
                            </Form.Group>

                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Poštanski broj</Form.Label>
                                <Form.Control name="posta" type="text" maxLength="11" onChange={e => this.onControlChange(e)} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <p></p>
                    <Row>
                        <Col>
                        </Col>
                        <Col className='d-flex justify-content-md-center'>
                            <Button variant="danger" onClick={() => this.onBtnSearch()} disabled={this.isDisabled()}>
                                <FontAwesomeIcon className={this.state.isLoading ? "fa-spin" : ""} icon={this.state.isLoading ? faSpinner: faMagnifyingGlass} /> Prikaži podatke
                            </Button>
                        </Col>
                        <Col className='d-flex justify-content-md-end '>
                            <Button variant="primary" onClick={() => this.onBtnXlsx()} disabled={this.isDisabled()}><FontAwesomeIcon icon={faFileExcel} /> Preuzmi XLSX</Button>
                            &nbsp;
                            <Button variant="success" onClick={() => this.onBtnCsv()} disabled={this.isDisabled()}><FontAwesomeIcon icon={faFileCsv} /> Prezumi CSV</Button>
                            &nbsp;
                            <Button variant="secondary" onClick={() => this.onBtnXml()} disabled={this.isDisabled()}><FontAwesomeIcon icon={faFileText} /> Prezumi XML</Button>
                        </Col>
                    </Row>
                    <p></p>
                    <Row>
                        <Col>
                            {dataComponent}
                            <div>{this.state.podnozje}</div>
                        </Col>
                    </Row>
                </Form>
            </>                
        )
    }
}
